import { RefiHttpClient } from '@cof/refi-web-sdk';
import { DebugService } from './debug.service.js';
import { stratum } from '../../../constants/stratum.js';

class _ExperimentService {
  constructor() {
    this.debug = new DebugService('ExperimentService');
    this.http = new RefiHttpClient();
    this._experiments = [];
    this._gapEducationVariant = null;
    this._gapMessagingRefinementVariant = null;
    this.abTest = null;
    this._abTests = {
      name: 'contract-ab-tests',
      variationIds: [],
      testGroup: '',
      testWeight: 1,
    };
  }

  updateExperiments(newExperiments, removeExperiments = []) {
    stratum.endAbTest(this.abTest);
    const configuredExperiments = newExperiments.map(experiment => experiment.toLowerCase());
    const updatedExperiments = this._experiments.filter(experiment => !removeExperiments.includes(experiment));
    this._experiments = Array.from(new Set(updatedExperiments.concat(configuredExperiments)));
    this._abTests.variationIds = this._experiments;
    this.abTest = stratum.startAbTest(this._abTests);
  }

  get experiments() {
    return this._experiments;
  }

  set experiments(experiments) {
    this._experiments = experiments;
  }

  get gapEducationVariant() {
    return this._gapEducationVariant;
  }

  set gapEducationVariant(value) {
    this._gapEducationVariant = value;
  }

  get gapMessagingRefinementVariant() {
    return this._gapMessagingRefinementVariant;
  }

  set gapMessagingRefinementVariant(value) {
    this._gapMessagingRefinementVariant = value;
  }
}
export const ExperimentService = new _ExperimentService();
